import React from "react";
import {
  Filter,
  TextInput,
  LongTextInput,
  ReferenceInput,
  SelectInput,
  Button,
  Link,
  Create,
  List,
  DateInput,
  NumberInput,
  Datagrid,
  TextField, FunctionField, ReferenceField,
  Pagination,
  DisabledInput,
  DateField,
  Edit,
  SimpleForm,
  EditButton,
  SaveButton,
  Toolbar,
  DeleteButton
} from "react-admin";
import ItemSwitch from "../components/itemSwitch";
import ChatBubbleIcon from "@material-ui/icons/ChatBubble";
import { CustomBaseFilter } from "../components/selectboxfilter/customBaseFilter";
import moment from "moment";
import { getPermissionRole } from "../util";
// import { isEmpty } from "ramda";
import styled from "styled-components";
const StyledDiv = styled.div((props) => ({
  flexDirection: "column",
  alignItems: props.align ? props.align : "center",
  justifyContent: props.justify ? props.justify : "center",
  backgroundColor: props.color,
  paddingTop: props.padding ? props.padding : "0px",
  paddingBottom: props.padding ? props.padding : "0px",
  minHeight: "40px",
  display: "flex",
  minWidth: "100px",
}));

const GpsPagination = props => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

const status = [
  { _id: "A", description: "Active" },
  { _id: "X", description: "Retired" }
];

const GpsFielter = props => (
  <Filter {...props}>
    <CustomBaseFilter label="Base Location" source="location_id" alwaysOn />
    <SelectInput
      label="Status"
      source="status"
      choices={status}
      optionText="description"
      optionValue="_id"
      alwaysOn
    />
  </Filter>
);

const HistoryButton = props => (
  <Button
    target="_blank"
    component={Link}
    to={{
      pathname: `/item_history/gps_devices/${props.record.id}`
    }}
    label="Device History"
  >
    <ChatBubbleIcon />
  </Button>
);

const SwitchButton = props => {
  const rentals = props.record.number_rentals || 0;
  if (rentals > 0 && props.record.status === "A") {
    return (
      <ItemSwitch
        item={props.record}
        type={props.resource}
        history={props.history}
        location={props.location}
      />
    );
  }
  return <React.Fragment />;
};

export const GpsList = props => {

  return (
    <List
      {...props}
      resource="gps_devices"
      pagination={<GpsPagination />}
      filters={<GpsFielter />}
      bulkActionButtons={false}
      filterDefaultValues={{ status: "A" }}
    >
      <Datagrid>
        <TextField label="Gps ID" source="id" sortable={false} />
        <ReferenceField
          label="Last Location"
          source="location_id"
          reference="locations" sortable={false}
          linkType={false}
        >
          <FunctionField
            label="Last Location"
            addLabel={false}
            render={(locations) => {
              return (
                <StyledDiv color={locations.color}>
                  {locations.location_name}
                </StyledDiv>
              );
            }}
          />
        </ReferenceField>

        {/* <TextField
          label="Last Location"
          source="location_name"
          sortable={false}
        /> */}
        <TextField label="Gps Model" source="model" sortable={false} />
        <DateField
          label="Purchase Date"
          source="purchase_date"
          sortable={false}
        />
        <EditButton />
        <HistoryButton />
        {([1, 5, 9].includes(getPermissionRole())) && ( 
          <SwitchButton {...props} /> 
        )}
      </Datagrid>
    </List>    
  )

};

const GpsTitle = object => (
  <span>
    {" Edit Gps Device"} &quot;{object.record.model}&quot;
  </span>
);

const GpsCreateTitle = record => <span>Create Gps Device</span>;

function Fecha(date){
  return moment.utc(date).locale('es').format('YYYY-MM-DD');
}

export const GpsCreate = props => (
  <Create title={<GpsCreateTitle />} {...props}>
    <SimpleForm>
      <TextInput label="Model" source="model" />
      <DateInput label="Purchase Date" source="purchase_date" locales="es-Es" options={{ timeZone: 'UTC' }} />
      <NumberInput source="purchase_price" label="Purchase Price" />
      <SelectInput
        label="Status"
        source="status"
        choices={[
          { id: "A", name: "Active" },
          { id: "X", name: "Inactive" }
        ]}
      />
      <ReferenceInput
        label="Primary Location"
        source="location_id"
        reference="locations"
        filter={{ only_bases: "true" }}
        sort={{ field: "location_name", order: "ASC" }}
      >
        <SelectInput source="id" optionText="location_name" />
      </ReferenceInput>
      <LongTextInput source="notes" label="Notes" />
    </SimpleForm>
  </Create>
);

const GpsEditToolbar = props => {
  return (
    <Toolbar {...props} style={{justifyContent: 'space-between' }}>
      <SaveButton {...props} disabled={![1, 5, 9].includes(getPermissionRole())} />
      <DeleteButton {...props} disabled={![1, 5, 9].includes(getPermissionRole())} />
    </Toolbar>
  );
};


export const GpsEdit = props => {
  return (
    <Edit title={<GpsTitle />} {...props}>
      <SimpleForm toolbar={<GpsEditToolbar />}> 
        <DisabledInput label="Id" source="id" />
        <TextInput label="Model" source="model" />
        <DateInput label="Purchase Date" source="purchase_date" locales="es-Es" options={{ timeZone: 'UTC' }} format={Fecha} />
        <NumberInput source="purchase_price" label="Purchase Price" />
        <SelectInput
          label="Status"
          source="status"
          choices={[
            { id: "A", name: "Active" },
            { id: "X", name: "Inactive" }
          ]}
        />
        <ReferenceInput
          label="Primary Location"
          source="location_id"
          reference="locations"
          filter={{ only_bases: "true" }}
          sort={{ field: "location_name", order: "ASC" }}
        >
          <SelectInput source="id" optionText="location_name" />
        </ReferenceInput>
        <LongTextInput source="notes" label="Notes" />
        <br />
        <HistoryButton />
      </SimpleForm>
    </Edit>
  )
};



// WEBPACK FOOTER //
// ./src/resources/gpsDevices.js